import { render, staticRenderFns } from "./DgssOrderForm.vue?vue&type=template&id=119baa49&scoped=true"
import script from "./DgssOrderForm.vue?vue&type=script&lang=js"
export * from "./DgssOrderForm.vue?vue&type=script&lang=js"
import style0 from "./DgssOrderForm.vue?vue&type=style&index=0&id=119baa49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119baa49",
  null
  
)

export default component.exports